import React from 'react';
import { List, Checkbox, Row, Input, Button, Modal } from 'antd';
import * as API from 'utils/api';

class ReportFooterCheckboxList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
      showInput: false,
      newItemText: '',
      data: this.props.data || [],
    };
  }

  handleCheckboxChange = (e, item) => {
    const { selectedItems } = this.state;
    const { onSelectionChange } = this.props;

    let newSelectedItems;
    if (e.target.checked) {
      newSelectedItems = [...selectedItems, item];
    } else {
      newSelectedItems = selectedItems.filter(i => i.id !== item.id);
    }

    this.setState({ selectedItems: newSelectedItems });

    if (onSelectionChange) {
      onSelectionChange(newSelectedItems);
    }
  };

  handleGenerateFooter = () => {
    const { selectedItems } = this.state;
    const { report_id } = this.props;

    const customFooterString = selectedItems
      .map(item => item.name)
      .join(', ');

    try {
      API.updateReport({
        id: report_id,
        custom_footer: customFooterString
      })

      Modal.success({
        content: 'Reference Footer has been generated!',
      });
    } catch(err) {
      console.error('Error updating footer:', err);
      Modal.error({
        content: 'Something went wrong...',
      });
    };

  };

  toggleInput = () => {
    this.setState(prevState => ({
      showInput: !prevState.showInput,
      newItemText: '',
    }));
  };

  handleInputChange = e => {
    this.setState({ newItemText: e.target.value });
  };

  handleInputConfirm = () => {
    const { newItemText, data } = this.state;

    if (newItemText.trim()) {
      const newItem = {
        id: Math.max(...data.map(item => item.id), 0) + 1,
        name: newItemText.trim(),
      };

      // Add new item to data and automatically select it
      const newSelectedItems = [...this.state.selectedItems, newItem];

      this.setState(prevState => ({
        data: [...prevState.data, newItem],
        selectedItems: newSelectedItems,
        showInput: false,
        newItemText: '',
      }));
    }
  };

  handleInputKeyPress = e => {
    if (e.key === 'Enter') {
      this.handleInputConfirm();
    }
  };

  render() {
    const {
      title,
      itemWidth = '300px',
      itemHeight = '80px',
      gridConfig = {
        gutter: 16,
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
        xxl: 6,
      },
    } = this.props;

    const { showInput, newItemText, data } = this.state;

    return (
      <>
        {title && (
          <Row className="sub-title">
            <span>{title}</span>
          </Row>
        )}
        <Row>
          <List
            style={{
              width: '100%',
            }}
            grid={gridConfig}
            dataSource={data}
            renderItem={item => (
              <List.Item style={{ width: itemWidth, height: itemHeight, marginBottom: '16px' }}>
                <Checkbox
                  onChange={e => this.handleCheckboxChange(e, item)}
                  checked={this.state.selectedItems.some(i => i.id === item.id)}
                  style={{ width: '100%' }}>
                  {item.name}
                </Checkbox>
              </List.Item>
            )}
          />
        </Row>
        <Row style={{ marginTop: '16px' }}>
          {showInput ? (
            <>
              <Input
                placeholder="Enter new reference"
                value={newItemText}
                onChange={this.handleInputChange}
                onKeyPress={this.handleInputKeyPress}
                style={{ width: '200px', marginRight: '8px' }}
                autoFocus
              />
              <Button type="primary" style={{ marginRight: '8px' }} onClick={this.handleInputConfirm}>
                Add
              </Button>
              <Button onClick={this.toggleInput}>Cancel</Button>
            </>
          ) : (
            <>
              <Button type="dashed" style={{ marginRight: '8px' }} onClick={this.toggleInput} icon={<span>+</span>}>
                Add Reference
              </Button>
              <Button type="primary" onClick={this.handleGenerateFooter}>
                Generate Footer
              </Button>
            </>
          )}
        </Row>
      </>
    );
  }
}

export default ReportFooterCheckboxList;
